import '../../styles/restScreens.css';
import React from 'react';

// ============================================================
// 7-stage chromatic progress bar (White -> Yellow -> Blue -> Green)
// Module 13 Task Management, per Module_13_Task_Management_v1_02.md §05
// ============================================================

const STOPS = [
  { pct: 0, color: '#E5E7EB', label: 'Not Started' },
  { pct: 15, color: '#FDE68A', label: 'Starting' },
  { pct: 30, color: '#FBBF24', label: 'Underway' },
  { pct: 50, color: '#38BDF8', label: 'Building' },
  { pct: 70, color: '#3B82F6', label: 'Progressing' },
  { pct: 90, color: '#34D399', label: 'Nearly There' },
  { pct: 100, color: '#10B981', label: 'Complete' },
];

function hexToRgb(hex) {
  const v = hex.replace('#', '');
  return [parseInt(v.slice(0, 2), 16), parseInt(v.slice(2, 4), 16), parseInt(v.slice(4, 6), 16)];
}

function lerp(a, b, t) {
  return Math.round(a + (b - a) * t);
}

export function getProgressColor(pct) {
  const p = Math.max(0, Math.min(100, pct || 0));
  let lo = STOPS[0];
  let hi = STOPS[STOPS.length - 1];
  for (let i = 0; i < STOPS.length - 1; i++) {
    if (p >= STOPS[i].pct && p <= STOPS[i + 1].pct) {
      lo = STOPS[i];
      hi = STOPS[i + 1];
      break;
    }
  }
  const span = hi.pct - lo.pct || 1;
  const t = (p - lo.pct) / span;
  const [r1, g1, b1] = hexToRgb(lo.color);
  const [r2, g2, b2] = hexToRgb(hi.color);
  return `rgb(${lerp(r1, r2, t)}, ${lerp(g1, g2, t)}, ${lerp(b1, b2, t)})`;
}

export function getProgressStageLabel(pct) {
  const p = Math.max(0, Math.min(100, pct || 0));
  let stage = STOPS[0];
  for (const s of STOPS) {
    if (p >= s.pct) stage = s;
  }
  return stage.label;
}

export default function ProgressBar({ progressPct = 0, theme = 'light', showLabel = true, size = 'md' }) {
  const color = getProgressColor(progressPct);
  const heightClass = size === 'sm' ? 'h-1.5' : 'h-2.5';

  return (
    <div data-m6-layout="tasks" data-m6-component="ProgressBar" className="w-full">
      {showLabel && (
        <div className="flex justify-between items-center mb-1">
          <span className={`text-xs font-medium ${theme === 'dark' ? 'text-gray-300' : 'text-gray-600'}`}>
            {getProgressStageLabel(progressPct)}
          </span>
          <span className={`text-xs font-semibold ${theme === 'dark' ? 'text-gray-200' : 'text-gray-700'}`}>
            {progressPct || 0}%
          </span>
        </div>
      )}
      <div className={`w-full ${heightClass} rounded-full overflow-hidden ${theme === 'dark' ? 'bg-gray-700' : 'bg-gray-200'}`}>
        <div
          className={`${heightClass} rounded-full transition-all duration-300`}
          style={{ width: `${Math.max(0, Math.min(100, progressPct || 0))}%`, backgroundColor: color }}
        />
      </div>
    </div>
  );
}
